import common from '@/store/common/mutations';
import types from './mutation-types';

export default {
	...common,

	[types.SET]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SET_SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParam[key] = value;
	}
};
